import { Tabs, TabsProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { PageHeader } from '../../shared/components/page-header'
import { CompanyPage } from '../company/company.page'
import { ProjectsPage } from '../projects/projects.page'
import { TariffsPage } from '../tariff/tariffs.page'

export const SettingsPage = () => {
  const { t } = useTranslation()

  const tabs: TabsProps['items'] = [
    {
      key: '1',
      label: t('settings.tariff'),
      children: <TariffsPage />,
    },
    {
      key: '2',
      label: t('settings.project'),
      children: <ProjectsPage />,
    },
    {
      key: '3',
      label: t('settings.organization'),
      children: <CompanyPage />,
    },
  ]

  return (
    <>
      <PageHeader header={t('settings.header')} />
      <Tabs
        defaultActiveKey="1"
        items={tabs}
      />
    </>
  )
}
